const data = {
  pageTableDate: [],
  tableData: {},
  tableDataForCDNote: {},
  pendingValue: {},
  JVTransactions: [],
  fromToValues: { from: "", to: "" },
  InputTableData: {},
};
export function TableDataReducer(state = data, { type, payload }) {
  switch (type) {
    case "PageTableDate": {
      return {
        ...state,
        pageTableDate: payload,
      };
    }
   
    case "InputTableData": {
      return { ...state, InputTableData: payload };
    }
    case "tableData": {
      return {
        ...state,
        tableData: { ...state.tableData, ...payload },
      };
    }
    case "CleartableData": {
      console.log(type);
      return { ...state, tableData: {} };
    }

    case "tableDataForCDNote": {
      return {
        ...state,
        tableDataForCDNote: { ...state.tableDataForCDNote, ...payload },
      };
    }
    case "PendingValue": {
      return {
        ...state,
        pendingValue: { ...state.pendingValue, ...payload },
      };
    }
    case "FromToValues": {
      return {
        ...state,
        fromToValues: { ...state.fromToValues, ...payload },
      };
    }
    default: {
      return state;
    }
  }
}
